var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Text from "../Text/Text";
import styled from "styled-components";
var getFlexDirection = function (labelPlacement) {
    switch (labelPlacement) {
        case "start":
            return "row-reverse";
        case "end":
            return "row";
        case "top":
            return "column-reverse";
        case "bottom":
            return "column";
        default:
            return "row";
    }
};
var StyledFormControl = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  gap: ", "px;\n  cursor: pointer;\n  user-select: none;\n  flex-direction: ", ";\n"], ["\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  gap: ", "px;\n  cursor: pointer;\n  user-select: none;\n  flex-direction: ", ";\n"])), function (props) { return props.$gap; }, function (props) { return getFlexDirection(props.$labelPlacement); });
var FormControlLabel = function (_a) {
    var control = _a.control, label = _a.label, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? "end" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.gap, gap = _d === void 0 ? 4 : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, props = __rest(_a, ["control", "label", "labelPlacement", "size", "gap", "disabled"]);
    var _disabled = control.props.disabled || disabled;
    return (_jsxs(StyledFormControl, __assign({ "$gap": gap, "$labelPlacement": labelPlacement, "$disabled": _disabled, "$size": size }, { children: [React.cloneElement(control, __assign(__assign({}, (!control.props.size && size && { size: size })), props)), _jsx("span", { children: typeof label === "string" ? (_jsx(Text, __assign({ variant: "paragraph", size: size }, { children: label }))) : (label) })] })));
};
export default FormControlLabel;
var templateObject_1;
